<template>
  <transition name="fade">
    <hcc-modal
      :clickToClose="false"
      :buttons="['exit']"
      name="label-modal"
      :title="$t('user-info-modal.title')"
      @closed="cleanData"
      customClass="label-modal"
    >
      <div class="form-modal">
        <p class="form-modal__title">{{ $t("user-info-modal.description") }}</p>
        <hcc-select
          :options="labelsAvailable"
          v-model="labelName"
          :searchable="false"
          :show-labels="false"
          option-label=""
          :label="label"
          :placeholder="$t('user-info-modal.select')"
          @select="focus"
          customClass="form-modal__select"
          requiredInput
        />
        <div class="form-modal__description">
          <hcc-input
            ref="labelInput"
            class="form-modal__description-input"
            :label="$t('user-info-modal.information')"
            v-model.trim="name"
            @keyup.enter="saveLabel"
          />
          <hcc-button
            @click="saveLabel"
            :disabled="disableButton"
            size="sm"
            class="form-modal__description-button"
            color="secondary"
            >{{ $t("user-info-modal.save") }}
          </hcc-button>
        </div>
        <info
          :remove="true"
          :userLabels="userLabels"
          v-on:remove-label="deleteLabel"
          labelManager
        />
      </div>
    </hcc-modal>
  </transition>
</template>

<script>
import { mapMutations } from 'vuex';
import Info from '@/components/labels/Info.vue';
import saveLabelGql from '@/graphql/mutations/saveLabel.gql';
import deleteLabelGql from '@/graphql/mutations/deleteLabel.gql';

export default {
  props: {
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    userLabels: {
      type: Array,
      required: true,
      default: () => [],
    },
    clientId: {
      type: String,
      required: true,
      default: null,
    },
  },
  components: {
    Info,
    HccModal: () => import('@/components/shared/HccModal/index.vue'),
    HccInput: () => import('@/components/shared/HccInput/index.vue'),
    HccSelect: () => import('@/components/shared/HccSelect/index.vue'),
    HccButton: () => import('@/components/shared/HccButton/index.vue'),
  },
  data() {
    return {
      labelName: null,
      name: null,
      loader: false,
    };
  },
  computed: {
    labelsAvailable() {
      const currentLabels = this.userLabels.map((label) => label.key);
      return this.options.filter((el) => !currentLabels.includes(el));
    },
    label() {
      return this.$t('user-info-modal.label');
    },
    disableButton() {
      return this.loader
        || this.labelsAvailable.length === 0
        || !this.name
        || !this.labelName;
    },

  },
  methods: {
    ...mapMutations([
      'setLabels',
    ]),
    reset() {
      this.labelName = null;
      this.name = null;
    },
    async saveLabel() {
      this.loader = true;
      this.blur();
      if (this.name !== null && this.name !== ''
        && this.labelName !== null && this.labelName !== '') {
        const labels = [...this.userLabels.map(({ key, value }) => ({ key, value })), {
          key: this.labelName,
          value: this.name,
        }];
        const { data: result } = await this.$apollo.mutate({
          mutation: saveLabelGql,
          variables: {
            id: this.clientId,
            name: null,
            labels,
          },
        });
        if (result.updateClient) {
          this.reset();
          this.setLabels({
            clientId: this.clientId,
            labels,
          });
        }
        this.loader = false;
      } else {
        this.loader = false;
      }
    },
    async deleteLabel({ key, ix }) {
      const { data: result } = await this.$apollo.mutate({
        mutation: deleteLabelGql,
        variables: {
          id: this.clientId,
          key,
        },
      });

      if (result.deleteClientLabelByKey) {
        const labels = [...this.userLabels];

        labels.splice(ix, 1);

        this.setLabels({
          clientId: this.clientId,
          labels,
        });
      }
    },
    cleanData() {
      this.labelName = null;
      this.name = null;
    },
    focus() {
      this.$refs.labelInput.focus();
    },
    blur() {
      this.$refs.labelInput.blur();
    },
    modalHeight() {
      return this.labelsAvailable.length > 4 ? '500' : 'auto';
    },
  },

};
</script>
